import * as React from "react";
import { AddressAddOption } from "./addOption/AddressAddOption";
import { CompanyAddOption } from "./addOption/CompanyAddOption";
import { DriverAddOption } from "./addOption/DriverAddOption";
import { VehicleAddOption } from "./addOption/VehicleAddOption";
import { ProductAddOption } from "./addOption/ProductAddOption";

export const TableDialogs: React.FC = () => {
  return (
    <>
      <AddressAddOption />
      <CompanyAddOption />
      <DriverAddOption />
      <VehicleAddOption />
      <ProductAddOption />
    </>
  );
};
